import * as modal from './modal';
import * as button from './button';

$(function () {

    // 送信（Submit）
    $("#sendSelect_submit").on("click", function () {
        // ボタンを無効に
        button.invalid(this);

        // セレクトした写真を取得
        let uuid_list = [];
        $('input:checkbox[name="selectimg"]:checked').each(function () {
            uuid_list.push($(this).val());
        });
        // セレクト内容送信
        sendSelect(uuid_list, send_name.value, this);
    });
});

// セレクト内容送信
function sendSelect(uuid_list, send_name, thisElem) {

    $.ajax({
        type: 'POST',
        url: mypath + `select/send`,
        data: {
            'album_uuid': album_uuid,
            'uuid_list': uuid_list,
            'send_name': send_name
        },
        dataType: 'json',
        scriptCharset: 'utf-8',
        cache: false
    })
        .then(
            function (res) {
                modal.startScroll();
                $('.overlay_modal').fadeOut();
                // ボタンを有効に
                button.valid(thisElem);

                if (res['flag']) {
                    Swal.fire({
                        title: '送信完了',
                        text: 'セレクト内容を送信しました。',
                        confirmButtonText: 'OK'
                    });
                } else {
                    Swal.fire({
                        title: 'エラー',
                        text: '送信に失敗しました',
                        confirmButtonText: 'OK'
                    });
                    console.log(res['error']);
                }
            },
            function (XMLHttpRequest, textStatus, errorThrown) {
                // ボタンを有効に
                button.valid(thisElem);

                // バリデーションエラー
                if (XMLHttpRequest.responseJSON.errors) {
                    Swal.fire({
                        title: '入力エラー',
                        text: '入力内容に誤りがあります',
                        confirmButtonText: 'OK'
                    });
                }
            });
}
